import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 引入全局样式
import '@/styles/index.scss'

// 引入工具函数
import { getImageUrl } from '@/utils'

// 使用Element UI
Vue.use(ElementUI)

// 注册全局方法
Vue.prototype.$getImageUrl = getImageUrl

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
